<template>
  <div class="last-quotation-item">
    <div class="quotation-tag" :class="tag.className">
      {{tag.label}}
    </div>
    <div>
      <ul class="row-content">
        <li class="info-col logo-col" :class="{blur: isBlurring}">
          <img :src="ossPath + '/pages/home/yun_warehouse/warehouse-pic-s.png'" alt="">
          <p class="title-info"><tooltipRow1 :contentInfo="quotation.overseasWarehouseAliasName || '/'" /></p>
        </li>
        <li class="info-col">
          <p><tooltipRow1 :contentInfo="quotation.portName || '/'" /></p>
          <p class="col-label">港口</p>
        </li>
        <li class="info-col">
          <p><tooltipRow1 :contentInfo="quotation.overseasCityName || '/'" /></p>
          <p class="col-label">拆柜城市</p>
        </li>
        <li class="info-col">
          <p><tooltipRow1 :contentInfo="quotation.cabinetName || '/'" /></p>
          <p class="col-label">柜型</p>
        </li>
        <li class="info-col price-info">
          <p class="primary-color weight-bold">
            <span>{{quotation.cnyCustomsClearancePrice && !isBlurring ? 'CNY' : ''}}</span>
            <span class="value" style="width: calc(100% - 30px)">
              <priceBlurring v-if="isBlurring" :contentInfo="quotation.cnyCustomsClearancePrice || '/'" />
              <tooltipRow1 v-else :contentInfo="quotation.cnyCustomsClearancePrice || '/'" />
            </span>
          <p class="col-label">海外清关费</p>
        </li>
        <li class="info-col price-info">
          <p class="primary-color weight-bold">
            <span>{{quotation.cnyLiftingPrice && !isBlurring ? 'CNY' : ''}}</span>
            <span class="value" style="width: calc(100% - 30px)">
              <priceBlurring v-if="isBlurring" :contentInfo="quotation.cnyLiftingPrice || '/'" />
              <tooltipRow1 v-else :contentInfo="quotation.cnyLiftingPrice || '/'" />
            </span>
          </p>
          <p class="col-label">提柜费</p>
        </li>
        <li class="info-col price-info">
          <p class="primary-color weight-bold">
            <span>{{quotation.cnyDismantlingPrice && !isBlurring ? 'CNY' : ''}}</span>
            <span class="value" style="width: calc(100% - 30px)">
              <priceBlurring v-if="isBlurring" :contentInfo="quotation.cnyDismantlingPrice || '/'" />
              <tooltipRow1 v-else :contentInfo="quotation.cnyDismantlingPrice || '/'" />
            </span>
          </p>
          <p class="col-label">拆柜费</p>
        </li>
        
        <li class="info-col price-info" style="min-width: 180px; padding-right: 20px">
          <template v-if="quotation.deliveryPriceList && quotation.deliveryPriceList.length">
            <div style="align-items: flex-end" v-for="deliveryPrice in quotation.deliveryPriceList" :key="deliveryPrice.id">
              <p class="col-label">{{{KP: '卡派', KDP: '快递派', ZT: '自提', WC: '整柜直送'}[deliveryPrice.deliveryType] || '/'}}</p>
              <p class="primary-color weight-bold" style="width: calc(100% - 60px)">
                <span>{{deliveryPrice.cnyDeliveryPrice && !isBlurring ? 'CNY' : ''}}</span>
                <span class="value" style="max-width: 50px; vertical-align: -3px">
                  <priceBlurring v-if="isBlurring" :contentInfo="deliveryPrice.cnyDeliveryPrice || '/'" />
                  <tooltipRow1 v-else :contentInfo="deliveryPrice.cnyDeliveryPrice || '/'" />
                </span>
                <span>{{deliveryPrice.billingUnit && !isBlurring ? `/${deliveryPrice.billingUnit}` : ''}}</span>
              </p>
            </div>
            <!-- <div style="align-items: center"  v-for="deliveryPrice in quotation.deliveryPriceList" v-if="deliveryPrice.deliveryType == 'ZT'">
              <p class="col-label">{{{KP: '卡派', KDP: '快递派', ZT: '自提', WC: '整柜'}[deliveryPrice.deliveryType] || '/'}}</p>
              <p class="primary-color weight-bold" style="width: calc(100% - 60px)">
                CNY
                <span class="value" style="max-width: 50px"><tooltipRow1 :contentInfo="deliveryPrice.cnyDeliveryPrice || '/'" /></span>
                {{deliveryPrice.billingUnit ? `/${deliveryPrice.billingUnit}` : ''}}
              </p>
            </div> -->
          </template>
          <template v-else>/</template>
          <!-- <div>
            <p class="col-label">快递派</p>
            <p class="primary-color weight-bold" style="width: calc(100% - 60px)">
              {{quotation.x ? 'CNY' : ''}}
              <span class="value"><tooltipRow1 :contentInfo="quotation.x || '/'" /></span>
              {{quotation.x ? `/${quotation.x}` : ''}}
            </p>
          </div>
          <div>
            <p class="col-label">自提</p>
            <p class="primary-color weight-bold" style="width: calc(100% - 60px)">
              {{quotation.x ? 'CNY' : ''}}
              <span class="value"><tooltipRow1 :contentInfo="quotation.x || '/'" /></span>
              {{quotation.x ? `/${quotation.x}` : ''}}
            </p>
          </div> -->
          
          <!-- <div>
            <p class="col-label">整柜直送</p>
            <p class="primary-color weight-bold" style="width: calc(100% - 60px)">
              {{quotation.x ? 'CNY' : ''}}
              <span class="value"><tooltipRow1 :contentInfo="quotation.x || '/'" /></span>
              {{quotation.x ? `/${quotation.x}` : ''}}
            </p>
          </div> -->
        </li>
        <li class="info-col col-action" style="line-height: 1">
          <p class="primary-color" @click="checkItem">
            价格详情<i class="el-icon-arrow-right"></i>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapState,mapGetters} from "vuex";
import tooltipRow1 from '@/components/placeOrder/components/tooltipRow1.vue'
import priceBlurring from '@common/priceBlurring'
export default {
  components: {
    tooltipRow1,
    priceBlurring
  },
  props: {
    quotation: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tagOptions: []
    }
  },
  computed:{
    ...mapGetters(["realNameState","token","realNameType","isInquiryUserSuccess"]),
    ...mapState(['Authorization']),
    // 是否需要模糊
    isBlurring(){
      if(this.priceDisplayType === 2) return false;
      if(!this.token) return true;
      if(this.Authorization.temporaryAuthentication) return false;
      if(this.isInquiryUserSuccess) return false;
      if(this.realNameType === 1 && this.realNameState === 1) return false;
      if(this.realNameType === 6 && this.realNameState === 1) return false;
      if(this.realNameState !== 3) return true;
      return false;
    },
    tag() {
      if (this.quotation.identificationType == '1') {
        return {
          label: '整柜',
          className: 'set'
        }
      } else {
        return {
          label: '拆柜',
          className: 'split'
        }
      }
      // return {
      //   label: '拆柜',
      //   className: 'split'
      // }
    }
  },
  methods: {
    checkItem() {
      this.$emit('checkItem')
    }
  }
}
</script>

<style lang="scss" scoped>
  .primary-color {
    color: #FF4D01
  }
  .weight-bold {
    font-weight: bold;
  }
  .last-quotation-item {
    position: relative;
    box-sizing: border-box;
    padding: 2px 10px;
    height: 70px;
    background: #F8F8F8;
    border-radius: 8px;
  }
  .quotation-tag {
    position: absolute;
    left: 0;
    top: 0;
    padding: 0 5px;
    line-height: 18px;
    font-size: 12px;
    color: #FFFFFF;
    border-radius: 8px 0px 6px 0px;
    z-index: 1;
    &.split { // 拆柜
      background: #FF6619;
    }
    &.set { // 整柜
      background: #FBA711;
    }
  }
  .row-content {
    display: flex;
    align-items: center;
    height: 70px;
    .info-col {
      width: 100%;
      max-width: 105px;
      padding-right: 10px;
      font-size: 12px;
      font-weight: 400;
      color: #FF4D01;
      line-height: 18px;
      font-size: 14px;
      color: #141414;
      // &.last-info-col {
      //   font-size: 12px;
      // }
      &.blur {
        filter: blur(5px);
      }
      &.logo-col {
        display: flex;
        align-items: center;
        flex-grow: 1;
        // width: 180px;
        // max-width: 180px;
        max-width: 100%;
        min-width: 180px;
        img {
          width: 50px;
          min-width: 50px;
          height: 50px;
          // background: #FFFFFF;
          border-radius: 4px;
          // border: 1px solid #EEEEEE;
        }
      }
      .title-info {
        margin-left: 10px;
        font-size: 16px;
        font-weight: bold;
        color: #141414;
        line-height: 22px;
        width: calc(100% - 60px)
      }
      &.price-info {
        font-size: 12px;
        flex-grow: 1;
        &>div {
          margin: 2px 0;
          display: flex;
          align-items: flex-end;
          // vertical-align: text-bottom;
          p {
            // vertical-align: text-bottom;
            line-height: 1;
            font-size: 0;
            span {
              font-size: 12px;
            }
            &.col-label { 
              font-size: 12px;
              width: 48px;
              margin-right: 10px;
            }
          }
        }
        .value {
          display: inline-block;
          vertical-align: -4px;
          font-size: 16px;
        }
      }
      &.col-action {
        width: 75px;
        min-width: 75px;
        font-size: 0;
        text-align: right;
        p {
          font-size: 14px;
          display: inline-block;
          cursor: pointer;
        }
      }
      .col-label {
        font-size: 12px;
        color: #999999
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/placeOrder/components/globalCloudWareQuotation/quotationItem.vue